import { MSUnit, MS_ADDON_SKUS, MS_BASE_UNIT_SKUS } from '@/js/pages/product/rackbuilder/utils/ms-utils/ms-constants'
import { getMassStorageEmailLayout } from '@/js/pages/product/rackbuilder/utils/ms-utils/ms-unit-label'
import type { CustomProductVariant } from '../types'

export const massStorageVariant: CustomProductVariant = {
  id          : 'mass-storage',
  featureFlag : 'enable-mass-storage',

  matches: (product, groupProduct) => {
    const sku = product?.sku
    const groupSku = groupProduct?.sku

    return (!!sku && MSUnit.includes(sku)) || (!!groupSku && MSUnit.includes(groupSku))
  },

  skuSets: {
    allSkus              : MSUnit,
    // Narrower than `allSkus` — deliberately excludes the grouped SKU.
    itemSkus             : [...MS_BASE_UNIT_SKUS, ...MS_ADDON_SKUS],
    mainSkus             : MS_BASE_UNIT_SKUS,
    qtyExcludedSkus      : MSUnit,
    addCountExcludedSkus : MS_ADDON_SKUS,
  },

  // Bolt-kit hardware lines carry hardwareCount and must still count toward cart qty despite their otherwise-excluded unit sku.
  readmitFromQty : (item) => !!item.metadata?.hardwareCount,
  // MS joins its addon/hardware siblings via metadata.recipe.
  purchaseKey    : (item) => item.metadata?.recipe,
  emailLayout    : getMassStorageEmailLayout,
}
